const namespace = 'workflows.validation.';

const translations = {
    invalidIfEmptyTarget: `${namespace}invalid_if_empty_target`,
    uniqueUserAssignTo: `${namespace}unique_user_assign_to`,
    uniqueUserBoth: `${namespace}unique_user_both`,
    uniqueUserReviewer: `${namespace}unique_user_reviewer`,
};

export { translations };
